import React, { useEffect, useState } from "react";
import { selectEmailRecipients, selectTemplatesLoading, selectTemplatesPag, selectTemplateTypes } from "../../redux/templates/selectors";
import { useDispatch, useSelector } from "react-redux";
import { Column, Button } from "devextreme-react/data-grid";
import { AdminTable } from "./AdminTable";
import { createTemplate, deleteTemplate, editTemplate, getEmailRecipients, getTemplatesPag, getTemplateTypes } from "../../redux/templates/thunks";
import { openModal } from "../../redux/modal/modalSlice";
import { TemplatesDialogue } from "./TemplatesDialogue";
import { removeHTMLTags } from "../../commonFunctions/FormatterFunctions";


const initialData = {
    templateId: null,
    name: "",
    templateCode: "",
    emailSubject: "",
    templateTypeId: null,
    text: "",
    recipients: null,
    recipientsCC : null
}

const initialSortOptions = {
    columna: "templateId",
    sortOrderAsc: true

}

function TemplatesManagement() { 
    const templates = useSelector(selectTemplatesPag);
    const templateTypes = useSelector(selectTemplateTypes)
    const emailRecipients = useSelector(selectEmailRecipients)
    const [openDialogue, setOpenDialogue] = useState(false)
    const [operation, setOperation] = useState()
    const [selectedTemplateData, setSelectedTemplateData] = useState(initialData)
    const [sortOptions, setSortOptions] = useState(initialSortOptions)

    const dispatch = useDispatch();
    const loading = useSelector(selectTemplatesLoading);
        
    const handleCalculateRecipientsCellDisplayValue = (rowData, field) => {
        return rowData[field].map(element => element.emailAddress).join(", ");
    }

    const columnsTemplates = [
        <Column sortIndex={1} key={"template-1"} dataField="name" caption="Nome"/>, 
        <Column key={"template-3"} dataField="text" caption="Mensagem" calculateDisplayValue={(rowData)=> removeHTMLTags(rowData.text)} />,
        <Column key={"template-4"} dataField="subject" caption="Assunto" />,
        <Column key={"template-5"} dataField={"templateTypeId"} caption="Tipo" lookup={{multiple: false, allowClearing: false, dataSource: templateTypes, displayExpr: "description", valueExpr: "id"}}/>,
        <Column key={"template-6"} dataField={"recipients"} caption="Destinatários" calculateDisplayValue={(rowData)=>handleCalculateRecipientsCellDisplayValue(rowData, "recipients")} lookup={{multiple: true, allowClearing: false, dataSource: emailRecipients, displayExpr: "emailAddress", valueExpr: "emailAddress"}}/>,
        <Column key={"template-7"} dataField={"recipientsCC"} caption="Destinatários CC" calculateDisplayValue={(rowData)=>handleCalculateRecipientsCellDisplayValue(rowData, "recipientsCC")}  lookup={{multiple: true, allowClearing: false, dataSource: emailRecipients, displayExpr: "emailAddress", valueExpr: "emailAddress"}}/>,
        <Column key={"acciones"} width={100} type="buttons">
            <Button onClick = { handleEditDialogOpen } hint={ "Editar" } icon = "edit" style={{ marginRight: '10px' }} />
            <Button visible={({row})=>row.data.custom} onClick={handleDeleteDialogOpen} hint={"Remover"} icon="trash" />
        </Column>
    ]    

    useEffect(()=>{
        getListTemplates(mapPageInfo(templates));
        dispatch(getTemplateTypes());
        dispatch(getEmailRecipients())
    },[])

    function mapPageInfo(templatesData){
        return {
            pageIndex: templatesData.pageIndex ?? 0,
            pageSize: templatesData.pageSize ?? 10,
            orderByField: templatesData.columna ?? "templateId",
            orderByAscending: templatesData.sortOrderAsc ?? true
        }
    }

    const getListTemplates = (pageInfo) => {
        let query= `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getTemplatesPag({query}));
    }

    function handleSaveNewTemplateClick(value) {        
        if(!value.templateTypeId){
            dispatch(openModal({type: "warning", message: "Por favor, preencha o campo tipo."}))
            return
        }
  
        const templateBody = {body: value}
        dispatch(createTemplate(templateBody)).then((data) => {
                if(data.error)
                    dispatch(openModal({ type: "warning", message:data.error.message}))
                else{
                     getListTemplates(mapPageInfo({...templates, ...sortOptions}));
                     dispatch(getEmailRecipients());
                     handleDialogClose()
                    }                    
                })     
    }    

    const handleEditClick = (value) => {
        
        if(!value.templateTypeId){
            dispatch(openModal({type: "warning", message: "Por favor, preencha o campo tipo."}))
            return
        }

        const recipients = value.recipients?.map(r=>r.emailAddress || r);
        const recipientsCC = value.recipientsCC?.map(r=>r.emailAddress || r);
        const editCaseStateParams ={
                    stateId: value.stateId,
                    body: {...value, recipients, recipientsCC}
                }
                dispatch(editTemplate(editCaseStateParams)).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListTemplates(mapPageInfo({...templates, ...sortOptions}));
                        dispatch(getEmailRecipients());
                        handleDialogClose()
                    }
                        
                })      
    }

    const handleDeleteClick = (value) => {
        dispatch(deleteTemplate({param:value})).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                let updatedPageIndex = templates.pageIndex;

                if (templates.elements.length === 1) {
                    updatedPageIndex = Math.max(0, templates.pageIndex - 1);
                }

                const updatedTemplates = {
                    ...templates,
                    pageIndex: updatedPageIndex,
                };

                getListTemplates(mapPageInfo({...updatedTemplates, ...sortOptions}));
                handleDialogClose()          
            }
        })  
    } 

    function handleEditDialogOpen(rowdata){
        setSelectedTemplateData(rowdata.row.data)
        setOperation("edit")
        setOpenDialogue(true)
    }

    
    function handleDeleteDialogOpen(rowdata){
        setSelectedTemplateData(rowdata.row.data)
        setOperation("delete")
        setOpenDialogue(true)
    }

    function handleDialogClose(){
        setOpenDialogue(false)
        setOperation(null)
        setSelectedTemplateData(initialData)
    }

    function handleCreateDialogOpen(){
        setOperation("create")
        setOpenDialogue(true)        
    }

    function handleSubmitForm(values){
        if(operation === "create")
            handleSaveNewTemplateClick(values)
        if(operation === "edit")
            handleEditClick(values)
        if(operation === "delete")
            handleDeleteClick(selectedTemplateData.templateId)
            
    }

    return(
        <div style={{width: "100%"}}>
            <AdminTable
                defaultSortField={"templateId"}
                sectionTitle={"Templates"}
                masterTitle={"Template"} 
                itemIdField={"templateId"} 
                itemDescriptionField={"name"} 
                loading={loading} 
                getData={getListTemplates} 
                dataSource={templates} 
                columnasTabla={columnsTemplates} 
                numElements={[10, 20, 30]}
                customCreation
                customEdition
                onCreate={handleCreateDialogOpen}
                sortField={sortOptions}
                setsortField={setSortOptions}
            />
            <TemplatesDialogue
                open={openDialogue}
                data={selectedTemplateData}
                operation={operation}
                onSubmitOperation={handleSubmitForm}
                handleDialogClose={handleDialogClose}

            />
        </div>
    )
} 
export default TemplatesManagement;